import { Action, createReducer, on } from "@ngrx/store";
import * as ProductionActions from "../../../actions/energy/self-sufficiency/production.actions";

export interface State {
  timestampsUnix: Array<number>;
  production: Array<number>;
}

const initialState: State = {
  timestampsUnix: undefined,
  production: undefined
};

const productionReducer = createReducer(
  initialState,
  on(ProductionActions.getSelfSufficiencyProductionData, (state) => ({
    ...state,
    timestampsUnix: undefined,
    production: undefined
  })),
  on(ProductionActions.getSelfSufficiencyProductionDataSuccess, (state, { payload }) => ({ ...state, ...payload }))
);

export function reducer(state: State | undefined, action: Action): State {
  return productionReducer(state, action);
}
